<template>
  <div
    class="supllier-data chart-wrap"
    ref="layoutBody"
  >
    <div class="legend">
      <div
        class="legend-inner"
        v-show="isShowLegend"
      >
        <div
          class="legend-item"
          v-for="(item, index) in legendList"
          :key="index"
        >
          <span
            class="icon"
            :style="{'background-color': item.color}"
          ></span>
          <span class="label">{{ item.label }}:</span>
          <span
            class="value"
            v-if="item.value"
          >{{ item.value }}</span>
        </div>
      </div>
    </div>
    <div>
      <SmoothedLineChart
        ref="smoothedLineChart"
        :data="list"
        :config="config"
        @showLegend="showLegend"
        @hideLegend="hideLegend"
      />
    </div>
  </div>
</template>

<script>
import SmoothedLineChart from '@/views/crm/charts/smoothed-line';
import setHeaderMixins from '@/mixins/set-header';
// import { parseTime } from '@/utils';
import { timeTypeMapXTitle, timeTypeMapYTitle } from '../data/index';
import chartLabelFormat from '../mixins/chart-format';

import { statsTrend } from '@/api/crm';
import NP from 'number-precision';
import { toThousands } from '@/utils/number';

export default {
  name: 'SupplierData',
  components: {
    SmoothedLineChart,
  },
  mixins: [setHeaderMixins, chartLabelFormat],
  data() {
    return {
      config: {
        xKey: 'time',
        yKey: 'value',
        xTitle: '时',
        yTitle: '金额（元）',
        groupKey: 'group',
        legendConfig: {
          统计数据: '#DE766F',
          对比数据: '#71A3F1',
        },
      },
      isShowLegend: false,
      legendList: [],
      list: [],
      // 接口参数
      form: {
        purchaserCode: '', // 采购商code
        fieldId: '', //  Q1200003: 订单数   Q1200001: GMV
        timeType: '', // 时间类型 -1:指定日期 0:全部 101:实时 102:天 201:周 301:月
        startDate: '', // 开始日期
        endDate: '', // 结束日期
        searchUserId: '', // 搜索的用户id
        searchDepartmentId: '', // 搜索部门id
        searchType: '',
      },
    };
  },
  watch: {
    $route() {
      // 监听 URL 改变, 重新获取查询参数, 并且发起请求
      // 修复 APP 因为缓存更改URL, 而 vue 的 this.query 不会重新获取导致类型没有更改
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.isShowLegend = false;
      const { query } = this.$route;
      const {
        fieldId = 'Q1200003', //  Q1200003: 订单数   Q1200001: GMV
        timeType = '101',
        startDate = '',
        endDate = '',
        searchUserId = '',
        searchDepartmentId = '',
        purchaserCode = '',
        searchType = '',
        searchInfo,
      } = query;
      const search = searchInfo ? JSON.parse(searchInfo) : '';
      this.form = {
        fieldId,
        timeType,
        startDate,
        endDate,
        searchUserId,
        searchDepartmentId,
        purchaserCode,
        searchType,
        searchInfo: search,
      };
      this.getLayout();
      this.getData();
    },
    // 让app端获取高度
    getLayout() {
      this.$nextTick(() => {
        const { layoutBody } = this.$refs;
        window.JSBridge.invoke({
          bridgeName: 'loadFinish',
          data: {
            height: layoutBody?.offsetHeight || 0,
            width: layoutBody?.offsetWidth || 0,
          },
          callback: () => {},
        });
      });
    },
    getData() {
      const groupList = Object.keys(this.config.legendConfig);
      this.config.xTitle = timeTypeMapXTitle[this.form.timeType];
      this.config.yTitle = timeTypeMapYTitle[this.form.fieldId];
      this.config.xAisRotate = this.form.timeType === '-1' || this.form.timeType === '301';
      let isShowYear = false;
      if (this.form.timeType === '-1') {
        const {
          startDate,
          endDate,
        } = this.form;
        isShowYear = startDate.slice(0, 4) !== endDate.slice(0, 4);
      }
      // 月份显示年。
      if (this.form.timeType === '301') {
        isShowYear = true;
      }
      statsTrend(this.form)
        .then((res) => {
          const data = res.data || [];
          let list = [];
          const xList = [];
          data.forEach((item, index) => {
            list = list.concat((item.trend || []).map((it, idx) => {
              const {
                value,
                label,
              } = it;
              let xAxis = label;
              if (!['101', '102'].includes(this.form.timeType)) {
                if (xList[idx]) {
                  xAxis = xList[idx];
                } else {
                  // 如果是自定义时间 判断是否跨年 如果跨年显示年份 19-01-01
                  xAxis = label.slice((isShowYear ? 2 : 5));
                  xList[idx] = xAxis;
                }
              }
              return {
                title: !['101', '102'].includes(this.form.timeType) ? label.slice(isShowYear ? 2 : 5) : label,
                value: Number(value),
                time: xAxis,
                group: groupList[index],
              };
            }));
          });
          this.list = list;
        });
    },
    // 处理长按数据
    showLegend(items) {
      const colorList = Object.values(this.config.legendConfig);
      const groupList = Object.keys(this.config.legendConfig);
      let legendList = new Array(colorList.length).fill(null);
      items.forEach((item) => {
        const {
          title,
          value,
          origin,
          color,
        } = item;
        const name = origin.group;
        const colorIndex = colorList.indexOf(color);
        if (colorIndex !== -1) {
          const label = this.handleLabel(name, this.form.timeType, origin.title);
          legendList[colorIndex] = {
            label,
            title,
            value,
            color,
          };
        }
      });

      const findItem = legendList.find(item => item);
      legendList = legendList.map((item, index) => {
        if (item) {
          return item;
        }
        const gType = groupList[index];

        const { title } = findItem;
        const label = this.handleLabel(gType, this.form.timeType, origin.title);
        return {
          label,
          title,
          value: '',
          color: colorList[index],
        };
      });
      this.legendList = legendList.map((item) => {
        let { value } = item;
        if (value) {
          if (value > 100000) {
            [value] = (NP.divide(value, 10000) || '').toString().split('.');
            value = `${toThousands(Number(value))}万`;
          } else {
            value = toThousands(Number(value));
          }
          item.value = value;
        }
        return item;
      });

      this.isShowLegend = true;
    },
    hideLegend() {
      this.isShowLegend = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .supllier-data {
    border-radius:5px;
    background-color: #FFFFFF;
    .title {
      font-size: 16px;
      color: #333333;
      padding: 22px 15px 0;
    }
  }
</style>
